import dates from 'services/api/calculators/dates';
import monetary from 'services/api/calculators/monetary';
import ons from 'services/api/calculators/ons';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'calculators';

/**
 * Calculator Resource Endpoints:
 *     - Date Calculators
 *     - Monetary Calculators
 */
export default {
    /**
     * Date Calculator Endpoints.
     *
     * @type {{}}
     */
    dates,
    /**
     * Monetary Calculator Endpoints.
     *
     * @type {{}}
     */
    monetary,
    /**
     * Ons Calculator Endpoints.
     *
     * @type {{}}
     */
    ons
};



// WEBPACK FOOTER //
// ./src/services/api/calculators.js